import type { BackendRouteDefinition } from '../types';

interface SaveAchPaymentMethodRequestData {
  routingNumber: string;
  accountNumber: string;
  billingName: string;
  firmId: string;
  idempotencyId: string;
}

export const saveAchPaymentMethodRoute = {
  transport: 'api',
  method: 'POST',
  path: '/firms/payment-methods/ach',
  // Keep the request body unchanged so the existing firms wrapper can switch
  // transports without remapping the legacy callable payload shape.
  body: (requestData: SaveAchPaymentMethodRequestData) => requestData,
} as const satisfies BackendRouteDefinition;
